var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page1 f1"},[_vm._v(" People ")])
}
var staticRenderFns = []

export { render, staticRenderFns }